import React from 'react'
import { connect } from 'react-redux'

import EmbeddedInsights from '../components/EmbeddedInsights'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { params } = ownProps
  const { studyID: study_id } = params
  const studyID = Number(study_id)
  const { studyDashboard } = state
  const { insights } = studyDashboard || {}
  const { dashboard_id: dashboard, embeddedUrl, vendor_type: vendorType, supersetData } = insights || {}

  return {
    studyID,
    dashboard,
    embeddedUrl,
    studyVersionID,
    vendorType,
    supersetData,
  }
}

export default connect(mapStateToProps)(props => {
  return <EmbeddedInsights {...props} />
})
